import { render, staticRenderFns } from "./uplImgAct.vue?vue&type=template&id=fbaa1100&scoped=true&"
import script from "./uplImgAct.vue?vue&type=script&lang=js&"
export * from "./uplImgAct.vue?vue&type=script&lang=js&"
import style0 from "./uplImgAct.vue?vue&type=style&index=0&id=fbaa1100&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaa1100",
  null
  
)

export default component.exports